import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../../config";
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from "recharts";

function EmployeePerformance() {
  const user = JSON.parse(localStorage.getItem("user"));
  const [cards, setCards] = useState([
    { id: 1, title: "Total Tasks", number: 0 },
    { id: 2, title: "Completed Tasks", number: 0 },
    { id: 3, title: "Pending Tasks", number: 0 },
  ]);
  const [performanceData, setPerformanceData] = useState([]);

  const fetchTasks = async () => {
    if (!user?.employeeId) return;
    try {
      const res = await axios.get(`${API_URL}/api/getTasksByEmployee/${user.employeeId}`);
      const tasksData = res.data || [];
      updateStats(tasksData);
      updatePerformanceChart(tasksData);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchTasks();
  }, [user]);

  const updateStats = (tasksList) => {
    const total = tasksList.length;
    const completed = tasksList.filter((t) => t.status === "Completed").length;
    const pending = total - completed;
    setCards([
      { id: 1, title: "Total Tasks", number: total },
      { id: 2, title: "Completed Tasks", number: completed },
      { id: 3, title: "Pending Tasks", number: pending },
    ]);
  };

  const updatePerformanceChart = (tasksList) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const data = months.map((m, idx) => {
      const count = tasksList.filter((task) => {
        if (task.status !== "Completed") return false;
        const taskMonth = new Date(task.dueDate).getMonth();
        return taskMonth === idx;
      }).length;
      return { month: m, score: count };
    });
    setPerformanceData(data);
  };

  const performanceScore = cards[0].number ? Math.round((cards[1].number / cards[0].number) * 100) : 0;

  return (
    <div className="emp-page-shell">
      <h2 className="emp-page-title">Performance Dashboard</h2>
      <p className="emp-page-subtitle">Monitor completion trend and monthly output performance.</p>

      <section className="emp-panel mb-3">
        <div className="emp-panel-body">
          <div className="emp-stat-grid">
            <article className="emp-stat-card emp-stat-score">
              <p>Performance Score</p>
              <h3>{performanceScore}%</h3>
            </article>
            <article className="emp-stat-card emp-stat-completed">
              <p>Tasks Completed</p>
              <h3>{cards[1].number}</h3>
            </article>
            <article className="emp-stat-card emp-stat-pending">
              <p>Pending Tasks</p>
              <h3>{cards[2].number}</h3>
            </article>
          </div>
        </div>
      </section>

      <section className="emp-panel">
        <div className="emp-panel-header">
          <h5 className="mb-1">Tasks Completed Per Month</h5>
        </div>
        <div className="emp-panel-body">
          <div className="emp-performance-chart">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={performanceData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Line type="monotone" dataKey="score" stroke="#3f6ea0" strokeWidth={3} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </section>
    </div>
  );
}

export default EmployeePerformance;
